export const VFJS_EVENT_FIELD_STATE_UPDATE = 'VFJS_EVENT_FIELD_STATE_UPDATE';
export const VFJS_EVENT_FIELD_MODEL_VALIDATE = 'VFJS_EVENT_FIELD_MODEL_VALIDATE';
export const VFJS_EVENT_FIELD_MODEL_UPDATE = 'VFJS_EVENT_FIELD_MODEL_UPDATE';
export const VFJS_EVENT_FIELD_MODEL_CLEAR_HIDDEN = 'VFJS_EVENT_FIELD_MODEL_CLEAR_HIDDEN';
export const VFJS_EVENT_FIELD_MODELS_VALIDATE = 'VFJS_EVENT_FIELD_MODELS_VALIDATE';
export const VFJS_EVENT_MODEL_UPDATE = 'VFJS_EVENT_MODEL_UPDATE';
export const VFJS_EVENT_MODEL_UPDATED = 'VFJS_EVENT_MODEL_UPDATED';
export const VFJS_EVENT_MODEL_VALIDATE = 'VFJS_EVENT_MODEL_VALIDATE';
export const VFJS_EVENT_STATE_UPDATE = 'VFJS_EVENT_STATE_UPDATE';
export const VFJS_EVENT_STATE_UPDATED = 'VFJS_EVENT_STATE_UPDATED';
export const VFJS_EVENT_UI_FIELDS_UPDATE = 'VFJS_EVENT_UI_FIELDS_UPDATE';
export const VFJS_EXTERNAL_EVENT_CHANGE = 'change';
export const VFJS_EXTERNAL_EVENT_STATE_CHANGE = 'state-change';
export const VFJS_EXTERNAL_EVENT_VALIDATED = 'validated';
export const VFJS_EXTERNAL_MODEL_PROP = 'model';
